const decorator = str => 'popups/' + str;

export const OPEN_POPUP = decorator('OPEN_POPUP');
export const CLOSE_POPUP = decorator('CLOSE_POPUP');
export const CHANGE_POPUP_PROPS = decorator('CHANGE_POPUP_PROPS');

export const REMOVE_FOCUS_FROM_POPUP = decorator('REMOVE_FOCUS_FROM_POPUP');
export const ADD_FOCUS_TO_POPUP = decorator('ADD_FOCUS_TO_POPUP');
